import React, { useEffect, useState } from 'react'
import { Box, Chip, Icon, Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import AdxInput from 'components/custom/AdxInput'
import AdxDropdownWithFilter from 'components/reusable/AdxDropdownWithFilter'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxInfoIcon from 'components/custom/AdxInfoIcon'
import AdxMultiselectWFilter from 'components/custom/AdxMultiselectWFilter'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getAllForm } from 'services/api/modules/performance/appraisal/form'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'
import AdxDropdown from 'components/custom/AdxDropdown'
import { createEvaluation } from 'services/api/modules/performance/appraisal/evaluation'
import AdxMenuItemCreateEval from 'components/custom/AdxMenuItemCreateEval'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'
import EvaluationSnackBar from '../components/EvaluationSnackBar'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const matching = [
  { id: 1, title: 'Self - Reviewer and Reviewee will be the same person' },
  { id: 2, title: 'Downstream - Supervisor as reviewer and Subordinate as reviewee' },
  { id: 3, title: 'Upstream - Subordinate as reviewer and Supervisor as reviewee' },
  {
    id: 4,
    title: 'Custom - Upload external matching CSV when this evaluation is added to an appraisal',
  },
]

function CreateEvaluation() {
  const navigate = useNavigate()
  const [evaluationTitle, setEvaluationTitle] = useState('')
  const [description, setDescription] = useState('')
  const [formList, setFormList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [switchFeedback, setSwitchFeedback] = useState(true)
  const [selectReviewer, setSelectReviewer] = useState(false)
  const [selectReviewee, setSelectReviewee] = useState(false)
  const [switchAnonymous, setSwitchAnonymous] = useState(false)
  const [selectForm, setSelectForm] = useState('')
  const [selectFormId, setSelectFormId] = useState('')
  const [selectDepartment, setSelectDepartment] = useState([])
  const [selectDepartmentId, setSelectDepartmentId] = useState([])
  const [selectMatching, setSelectMatching] = useState('')
  const [dropdownFilterOptionsForm, setDropDownFilterOptionsForm] = useState(formList)
  const [dropdownFilterOptionsDept, setDropDownFilterOptionsDept] = useState(departmentList)
  const [departmentAll, setDepartmentAll] = useState(false)
  const [getError, setGetError] = useState()
  const [checkAllDept, setCheckAllDept] = useState([])
  const [excludeAllDeptList, setExcludeAllDeptList] = useState([])
  const [showDept, setShowDept] = useState([])
  const [showError, setShowError] = useState(false)

  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.resetQueries('allDepartmentData')
    queryClient.invalidateQueries('allDepartmentData')
  }, [])

  const { data: formData } = useQuery('allFormData', async () => {
    const { data } = await getAllForm()
    return data
  })

  const { data: departmentData } = useQuery('allDepartmentData', async () => {
    let newData = [{ name: 'Select All Departments', id: 'all' }]
    const { data } = await getAllDepartment()
    setExcludeAllDeptList(data)
    data.map((item, index) => newData.push(data[index]))
    return newData
  })

  const { error: createError, mutate: createMutate } = useMutation(createEvaluation, {
    onSuccess: () => {
      navigate('/app/management-centre/company-management/appraisal')
    },
    onError: (error) => {
      if (Object.keys(error?.data?.errors).length > 1) {
        setGetError(Object.values('You have incomplete fields'))
      } else {
        setGetError('You have an incomplete field')
      }
      setShowError(true)
    },
  })

  useEffect(() => {
    setFormList(formData?.form ?? [])
    setDepartmentList(departmentData ?? [])
  }, [formData, departmentData])

  const handleFormSelection = (event) => {
    setSelectForm(event.target.value)
    setSelectFormId(event.target.value.id)
  }

  const onChangeTitle = (event) => {
    setEvaluationTitle(event.target.value)
  }

  const onChangeDesc = (event) => {
    setDescription(event.target.value)
  }

  const handleDepartmentSelection = (event) => {
    let department = []
    const specificObj = { name: 'All Departments', id: 'all' }

    let {
      target: { value },
    } = event

    // To check previous & current selection if "Select All Department" is selected or not. Initial value of checkAllDept will be []. If deselectAllDept === true, the value will be empty
    const deselectAllDept = checkAllDept.some(
      (element) =>
        element.id === specificObj.id &&
        !value.some((currentElement) => currentElement.id === specificObj.id)
    )
    setCheckAllDept(value)

    if (deselectAllDept) {
      value = []
    }

    if (!departmentAll) {
      if (value.find((object) => object.id === 'all')) {
        value = departmentData
        setDepartmentAll(true)
      }
    } else {
      if (value.find((object) => object.id === 'all')) {
        value.splice(
          value.findIndex((obj) => obj.id === 'all'),
          1
        )
      }
      setDepartmentAll(false)
    }

    if (excludeAllDeptList.every((element) => value.includes(element))) {
      value = departmentData
      setCheckAllDept(value)
    }

    department = value.flatMap((i) => i.id)
    department = department.find((element) => element === 'all') ? ['all'] : department

    setSelectDepartmentId(department)
    setSelectDepartment(value)
    setShowDept(value.find((element) => element.id === 'all') ? [specificObj] : value)
  }

  const handleMatchingSelection = (event) => {
    setSelectMatching(event.target.value)
  }

  const handleReviewer = () => {
    setSelectReviewer(!selectReviewer)
  }
  const handleReviewee = () => {
    setSelectReviewee(!selectReviewee)
  }

  const handleCreateEval = () => {
    let newEval = {
      title: evaluationTitle,
      description: description,
      is_anonymous: switchAnonymous ? 1 : 0,
      is_revieweeView: selectReviewee ? 1 : 0,
      is_reviewerView: selectReviewer ? 1 : 0,
      has_feedback: switchFeedback ? 1 : 0,
      form_id: selectForm.id,
      department_ids: selectDepartmentId,
      matching_id: selectMatching,
    }
    createMutate(newEval)
  }

  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        maxWidth: '100vw',
        gap: 2,
        pb: 3,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {/* Header */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white.main',
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
          position: 'sticky',
          top: 0,
          zIndex: 999,
          px: 3,
          py: 2,
        }}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Typography variant="h4">
            {evaluationTitle ? evaluationTitle : 'New Evaluation Setting'}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
          <AdxButton sx={{ width: 135 }} onClick={handleCreateEval}>
            Create
          </AdxButton>
          <Icon
            onClick={() => navigate('/app/management-centre/company-management/appraisal')}
            sx={{ fontSize: 25, cursor: 'pointer' }}
          >
            close
          </Icon>
        </Box>
      </Box>
      <EvaluationSnackBar
        message={getError}
        status={'error'}
        autoHideDuration={4000}
        showError={showError}
        setShowError={setShowError}
      />

      {/* Body */}

      {/* General */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            General
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          {/* Textfield for Evaluation Name */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Name</Typography>
            <AdxInput
              value={evaluationTitle}
              placeholder="E.g. Evaluation for Employees"
              charLimit={50}
              onChange={onChangeTitle}
              isErrorShown={createError?.data?.errors?.title}
              errorMessage={<AdxErrorMessage children={createError?.data?.errors?.title} />}
            />
          </Box>

          {/* Textfield for Description */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Description</Typography>
            <AdxInput
              value={description}
              multiline
              placeholder="Type here"
              charLimit={500}
              onChange={onChangeDesc}
              isErrorShown={createError?.data?.errors?.description}
              errorMessage={<AdxErrorMessage children={createError?.data?.errors?.description} />}
            />
          </Box>

          {/* Dropdown for selecting FORM */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Form Selection</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <AdxDropdownWithFilter
                allOptions={formList}
                setOptions={setDropDownFilterOptionsForm}
                sx={{ width: '80%' }}
                value={selectForm}
                onChange={handleFormSelection}
                renderValue={(option) => {
                  return (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Typography variant="body1">{option.title}</Typography>
                      </Box>
                    </Box>
                  )
                }}
                isErrorShown={createError?.data?.errors?.form_id}
                errorMessage={<AdxErrorMessage children={createError?.data?.errors?.form_id} />}
              >
                {dropdownFilterOptionsForm.map((item, index) => (
                  <AdxMenuItemCreateEval key={index} value={item} selectedvalue={selectForm}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Typography variant="body1">{item.title}</Typography>
                      </Box>
                    </Box>
                  </AdxMenuItemCreateEval>
                ))}
              </AdxDropdownWithFilter>
              {selectForm && (
                <Link
                  to={`/app/management-centre/company-management/appraisal/form/preview/${selectFormId}`}
                  target="_blank"
                >
                  <AdxButton
                    // onClick={handlePreview}
                    sx={{ width: 200 }}
                  >
                    Preview
                  </AdxButton>
                </Link>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Participant */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Participant
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography variant="body1">Department Selection </Typography>
              <AdxInfoIcon toolTipTitle="Choose specific or multiple department" />
            </Box>
            <AdxMultiselectWFilter
              allOptions={departmentList}
              setOptions={setDropDownFilterOptionsDept}
              multiple
              sx={{ width: '100%' }}
              value={selectDepartment}
              onChange={handleDepartmentSelection}
              renderValue={() => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      overflowX: 'auto',
                    }}
                  >
                    {showDept.map((value) => (
                      <Chip key={value.id} label={value.name} />
                    ))}
                  </Box>
                )
              }}
              isErrorShown={createError?.data?.errors?.department_ids}
              errorMessage={
                <AdxErrorMessage children={createError?.data?.errors?.department_ids} />
              }
            >
              {dropdownFilterOptionsDept.map((item, index) => (
                <AdxMenuItemCreateEval
                  key={index}
                  value={item}
                  selectedvalue={selectDepartment}
                  // onChange={handleDepartmentSelection}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="body1">{item.name}</Typography>
                  </Box>
                </AdxMenuItemCreateEval>
              ))}
            </AdxMultiselectWFilter>
          </Box>
          {/* Matching rule */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography variant="body1">Matching Method </Typography>
              <AdxInfoIcon toolTipTitle="Select method to assign reviewer(s) to reviewee" />
            </Box>

            <AdxDropdown
              sx={{ width: '100%' }}
              sxLabel={{
                color: 'alternate.main' /*, fontSize: "30px!important" */,
                fontSize: '30px',
              }}
              value={selectMatching}
              onChange={handleMatchingSelection}
              isErrorShown={createError?.data?.errors?.matching_id}
              errorMessage={<AdxErrorMessage children={createError?.data?.errors?.matching_id} />}
            >
              {matching.map((item, index) => (
                <AdxMenuItem key={index} value={item['id']} selectedvalue={selectMatching}>
                  {item['title']}
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Other
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          {' '}
          {/* <Box>
            <Typography variant="body1">Evaluation Result Visibility:</Typography>
            <Typography variant="subtitle2" color="gray">
              Evaluation results will be visible to the selected type of user(s).
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <AdxFormControlLabel
              type="no-fill"
              control={<AdxCheckbox onChange={handleReviewer} />}
              label="Reviewer"
            />
            <AdxFormControlLabel
              type="no-fill"
              control={<AdxCheckbox onChange={handleReviewee} />}
              label="Reviewee"
            />
          </Box> */}
          {/* Enabling evaluation feedback */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Evaluation feedback</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to leave feedback after they have reviewed their evaluation result.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchFeedback}
              onChange={() => {
                setSwitchFeedback(!switchFeedback)
              }}
            />
          </Box>
          {/* Anonymous submission */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Anonymous submission</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to submit evaluation anonymously.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchAnonymous}
              onChange={() => {
                setSwitchAnonymous(!switchAnonymous)
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default CreateEvaluation
